import { AspectRatio, CssVarsProvider } from "@mui/joy";
import Card from "@mui/joy/Card";
import { Box, Container, Stack } from "@mui/material";
import CardOverflow from "@mui/joy/CardOverflow";
import Typography from "@mui/joy/Typography";
import React from "react";

const authorsOfThisTime = [
  {
    name: "Daniel Kahneman",
    line: "Thinking & Decision-Making",
    image: "/img/daniel.webp",
  },
  {
    name: "James Clear",
    line: "Habits & Self-Improvement",
    image: "/img/james.jpeg",
  },
  {
    name: "Morgan Housel",
    line: "Money & Behavior",
    image: "/img/Morgan.jpg",
  },
];

export default function ActiveUsers(){
    return (
    <div className="active-users-frame">
        <Container>
            <Stack className="main">
                <Box className="home-section-head">
                    <Box className="home-section-titleblock">
                        <Box className="category-title">Authors of this time</Box>
                        <Box className="home-section-subtitle">
                            Three standout names readers are discovering most this season.
                        </Box>
                    </Box>
                    
                </Box>

                <Stack className="cards-frame">
                    <CssVarsProvider>
                        {authorsOfThisTime.map((author) => (
                            <Card key={author.name} variant="outlined" className="card">
                                <CardOverflow>
                                    <AspectRatio ratio="1">
                                        <img src={author.image} alt={author.name} />
                                    </AspectRatio>
                                </CardOverflow>
                                <CardOverflow>
                                    <Box className="member-nickname">
                                        <Typography>{author.name}</Typography>
                                    </Box>
                                    <Box className="member-role">
                                        {author.line}
                                    </Box>
                                </CardOverflow>
                            </Card>
                        ))}
                    </CssVarsProvider>
                </Stack>
            </Stack>
        </Container>
    </div>
    );
}